var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('service-quest-list',{attrs:{"param":{ status: 1 },"category":1,"canNew":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }